module.exports = __webpack_public_path__ + "img/inform.785072c3.png";